// @flow
import $ from 'jquery';
import JQueryView, { on } from '../../../common/JQueryView';

export default class NewView extends JQueryView {
  constructor() {
    super('.company.irs.reports.new');
    renderAllCheckbox();
  }

  @on({ event: 'change', selector: 'input[name="all_checked"]' })
  onChangeAllCheck() {
    const allChecked = $('input[name="all_checked"]').prop('checked');
    if (allChecked) {
      $('input[type=checkbox]')
        .not(':hidden')
        .not(':disabled')
        .prop('checked', true);
    } else {
      $('input[type=checkbox]')
        .not(':hidden')
        .prop('checked', false);
    }
  }

  @on({ event: 'change', selector: $('input[type=checkbox]') })
  onChangeAllCheckbox() {
    renderAllCheckbox();
  }

  // 絞り込みボタンで呼び出すモーダルの種類を切り替える
  @on({ event: 'click', selector: '.filter-tabs button' })
  changeAmountFilterType(event: Event) {
    $('.btn-amount-filter').removeClass('active disabled');
    $('.btn-amount-filter').attr('data-toggle', 'modal');
    const targetClass = $(event.target).attr('class');

    if (targetClass.includes('rightholders')) {
      $('.btn-amount-filter').attr(
        'data-target',
        '#rights_amount-filter-modal',
      );
    } else if (targetClass.includes('stockholders')) {
      $('.btn-amount-filter').attr(
        'data-target',
        '#stocks_amount-filter-modal',
      );
    } else {
      $('.btn-amount-filter').addClass('disabled');
      $('.btn-amount-filter').attr('data-toggle', '');
    }
  }

  // 絞り込みボタン
  @on({
    event: 'click',
    selector:
      '#btn-stocks_amount-filter-execute, #btn-rights_amount-filter-execute',
  })
  filterByAmount(event: any) {
    $('.btn-amount-filter').removeClass('active');
    const filterType = event.target.id.includes('stocks_amount')
      ? 'stocks_amount'
      : 'rights_amount';
    const amountGteq = parseInt($(`#${filterType}-gteq`).val());
    const amountLteq = parseInt($(`#${filterType}-lteq`).val());
    if (this.validateFilterAmount(filterType, amountGteq, amountLteq)) return;

    // タブをクリックした直後の表示内容から、さらに数量で絞り込みをする
    $('.filter-tabs .active').trigger('click');
    $(`.${filterType}-value`).each(function() {
      const amount = parseInt($(this).text());
      if (
        amount === 0 ||
        (amountGteq && amount < amountGteq) ||
        (amountLteq && amount > amountLteq)
      ) {
        $(this)
          .parent('tr')
          .hide();
      }
    });
    $('.btn-amount-filter').addClass('active');
    $('.modal').modal('hide');
  }

  validateFilterAmount(
    filterType: string,
    amountGteq: number,
    amountLteq: number,
  ) {
    $(`#${filterType}-filter-modal .invalid-feedback`).remove();

    // type="number"のinputに全角文字列が入力された場合、入力が残ったまま入力無し扱いにされるため、空欄にする
    if (isNaN(amountGteq)) $(`#${filterType}-gteq`).val('');
    if (isNaN(amountLteq)) $(`#${filterType}-lteq`).val('');

    const errorMessage = this.getValidateMessageOfFilterAmount(
      amountGteq,
      amountLteq,
    );
    if (errorMessage) {
      $(`#${filterType}-filter-modal input`).addClass('is-invalid');
      $(`#${filterType}-filter-modal .modal-body`).append(
        `<small class='invalid-feedback'>${errorMessage}</small>`,
      );
      return true;
    } else {
      $(`#${filterType}-filter-modal input`).removeClass('is-invalid');
    }
    return false;
  }

  getValidateMessageOfFilterAmount(amountGteq: number, amountLteq: number) {
    if (
      amountGteq < 1 ||
      amountLteq < 1 ||
      (isNaN(amountGteq) && isNaN(amountLteq))
    )
      return '1以上の半角数字を入力してください';
    if (amountGteq > amountLteq)
      return '最高数は最低数よりも大きな半角数字を入力してください';
  }
}

export function renderAllCheckbox() {
  const selectedCount = $(
    'input:checkbox:checked[id^="company_ir_ir_stakeholders_attributes_"], input:checkbox:checked[id^="company_ir_send_fundinno_community_"]',
  )
    .not(':hidden')
    .not(':disabled').length;
  const totalCount = $(
    'input:checkbox[id^="company_ir_ir_stakeholders_attributes_"], input:checkbox[id^="company_ir_send_fundinno_community_"]',
  )
    .not(':hidden')
    .not(':disabled').length;

  if (totalCount === selectedCount) {
    $('input[name="all_checked"]').prop('checked', true);
  } else {
    $('input[name="all_checked"]').prop('checked', false);
  }
}
